module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/EXPERIENCES_02-infinityedgePool.png";